import React, { useState, useRef, useEffect } from "react";
import { MessageCircle, X } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export default function WhatsAppFloat() {
 const [open, setOpen] = useState(false);
 const { locale } = useLanguage();
 const l = (fr, en, pt) => locale === "en" ? en : locale === "pt" ? pt : fr;
 const ref = useRef(null);

 useEffect(() => {
 const onClick = (e) => {
 if (ref.current && !ref.current.contains(e.target)) setOpen(false);
 };
 if (open) document.addEventListener("mousedown", onClick);
 return () => document.removeEventListener("mousedown", onClick);
 }, [open]);

 return (
 <div ref={ref} className="fixed bottom-6 left-6 z-40" data-testid="whatsapp-float">
 {open && (
 <div className="absolute bottom-16 left-0 bg-nanda-bg border border-nanda-line shadow-xl p-4 min-w-[260px] animate-in fade-in slide-in-from-bottom-2 duration-300">
 <div className="label-overline text-nanda-muted mb-3">WhatsApp</div>
 <a
 href="https://wa.me/245956828351"
 target="_blank"
 rel="noopener noreferrer"
 className="flex items-center justify-between gap-4 py-3 border-b border-nanda-line hover:text-nanda-terracotta transition-colors group"
 data-testid="whatsapp-float-gw"
 onClick={() => setOpen(false)}
 >
 <span>
 <div className="text-nanda-ink text-sm font-medium">{l("Guinée-Bissau", "Guinea-Bissau", "Guiné-Bissau")}</div>
 <div className="text-nanda-inkSoft text-xs mt-0.5">+245 956 828 351</div>
 </span>
 <MessageCircle size={16} strokeWidth={1.5} className="text-nanda-muted group-hover:text-nanda-terracotta" />
 </a>
 <a
 href="https://wa.me/221710090410"
 target="_blank"
 rel="noopener noreferrer"
 className="flex items-center justify-between gap-4 py-3 hover:text-nanda-terracotta transition-colors group"
 data-testid="whatsapp-float-sn"
 onClick={() => setOpen(false)}
 >
 <span>
 <div className="text-nanda-ink text-sm font-medium">{l("Guinée-Bissau", "Guinea-Bissau", "Guinea-Bissau")}</div>
 <div className="text-nanda-inkSoft text-xs mt-0.5">+221 71 009 04 10</div>
 </span>
 <MessageCircle size={16} strokeWidth={1.5} className="text-nanda-muted group-hover:text-nanda-terracotta" />
 </a>
 </div>
 )}
 <button
 type="button"
 onClick={() => setOpen((v) => !v)}
 aria-label="WhatsApp NANDA SÁ"
 aria-expanded={open}
 data-testid="whatsapp-float-toggle"
 className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-nanda-terracotta text-white shadow-lg hover:bg-[#8F5B3F] transition-colors duration-500"
 >
 {open ? <X size={20} strokeWidth={1.5} /> : <MessageCircle size={20} strokeWidth={1.5} />}
 </button>
 </div>
 );
}
